var HafasWidgetGenerator = function (params) {
  document.title = Hafas.Modules.i18n.get(Hafas.Config.Widgetgenerator.description);
  if(Hafas.Modules.a11y) Hafas.Modules.a11y.Announce.polite(document.title);

  window.addEventListener('resize', function (event) {
    // Geht leider nur mit Timeout
    // Grund: Wenn man den Browser über den "Maximize" Button vergrößert dann verhält sich die Resize-Logik anders
    // Kann mit timeout 0 umgangen werden
    setTimeout(function () {
      Hafas.ps.pub('/widgetgenerator/resizeWindow');
    }, 0);
  }, false);

  this.formContainer = 'HFS_Widgetgenerator';
  if (typeof this.subscriptions.WidgetGenerator != 'undefined') {
    this.subscriptions.WidgetGenerator(this);
  }

  Hafas.ps.pub('/common/subscriptions/done');

  window.addEventListener("message", function (message) {
    if (typeof message.data.type != 'undefined' && message.data.type == 'widgetLoadingState') {
      var id = message.data;
      var previewLoader = Hafas('#HFS_WidgetgeneratorPreviewLoader_' + message.data.id, false);
      if (previewLoader) {
        previewLoader.addClassName('lyr_previewLoaderHidden')
      }
    }
  }, false);

  // Allgemeine Einstellungen aus Config für Widgetgenerator übernehmen
  this.Controller.WidgetGenerator.settings = {
    lang: Hafas.Config.currLangObj.lang,
    layout: "widget",
    features: {}
  };

  // Prüfen welche Features aktiviert sind
  for (var f in Hafas.Config.Widgetgenerator.features) {
    var currFeature = Hafas.Config.Widgetgenerator.features[f];
    this.Controller.WidgetGenerator.settings.features[f] = currFeature;
    this.Controller.WidgetGenerator.settings.features[f].data = {};
    if (typeof currFeature.defaultData != 'undefined') {
      this.Controller.WidgetGenerator.settings.features[f].data = currFeature.defaultData;
    }
  }

  Hafas.Core.newType("hafasAtoms", {
    Controller: this.Controller
  });

  this.Controller.WidgetGenerator.main = this;
  Hafas.bind(this.Controller.WidgetGenerator.index, this)();

  if (typeof Hafas.getWebAppContext == 'undefined') {
    Hafas.getWebAppContext = function () {
      return "WidgetGenerator";
    }
  }
};